import React from 'react';

import FileDownload from '../Medata/search/civil/components/FileDownload';
import Resource from '../Medata/search/civil/components/Resource';
import DataTable from '../Medata/search/civil/templates/DataTable';
import DataTableHeader from '../Medata/search/civil/templates/DataTableHeader';
import DatasetFrame from '../Medata/dataset/dataset-frame';
import { JsonToTable } from '../Medata/search/civil/components/JsonToTable';
import { Link } from '@reach/router';

const ResourceTemplate = ({ resource, id }) => {
  const type =
    resource.hasOwnProperty('data') && resource.data.hasOwnProperty('mediaType')
      ? resource.data.mediaType.split('/')
      : '';
  const backup = type ? type[1] : 'data';
  const format =
    resource.hasOwnProperty('data') && resource.data.hasOwnProperty('format')
      ? resource.data.format
      : backup;

  const downloadURL =
    resource.hasOwnProperty('data') &&
      resource.data.hasOwnProperty('downloadURL')
      ? resource.data.downloadURL
      : '';
  const accessURL =
    resource.hasOwnProperty('data') && resource.data.hasOwnProperty('accessURL')
      ? resource.data.accessURL
      : downloadURL;
  const rootURL = `${process.env.REACT_APP_ROOT_URL}/`;

  function getResourceRender(format) {
    if (!format) return null;
    let content = null;
    switch (format) {
      case 'csv':
        content = (
          <>
            <div className='containerResource'>
              <p className='subtitle subtitle--black'><b>{resource.data.title}</b></p>
              <div className='containerResourceButtons'>
                <FileDownload
                  title={'Descargar'}
                  label={'Descargar'}
                  format={format}
                  downloadURL={downloadURL ? downloadURL : accessURL}
                  id={id}
                />
                <div className='data-actions pl-2'>
                  <a href={`/resource/${resource.identifier}`} title="Ver" className='button button-secondary' target='_blank'>
                    <i className='fa-solid fa-eye' />
                    {` Visualizar`}
                  </a>
                </div>
              </div>
            </div>
            <Resource
              apiURL={rootURL}
              identifier={resource.identifier}
              resource={resource}
              showDBColumnNames={true}
            >

              <DataTableHeader />
              <DataTable />
            </Resource>
            <hr />
          </>
        );
        break;
      case 'tablero':
      case 'iframe':
        content = (
          <div>
            <DatasetFrame url={downloadURL ? downloadURL : accessURL} />
            {/* <hr />
            <FileDownload
              title={`${resource.data.title || 'URL'} (Clic para ver)`}
              label={resource.data.downloadURL}
              format={format}
              downloadURL={downloadURL ? downloadURL : accessURL}
            /> */}
          </div>
        );
        break;
      case 'html':
        content = (
          <FileDownload
            title={'Ir al recurso'}
            label={'Ir al recurso'}
            format={format}
            downloadURL={downloadURL ? downloadURL : accessURL}
          />
        );
        break;
      case 'json':
        content = (
          <>
            <JsonToTable url={downloadURL ? downloadURL : accessURL} />
            <FileDownload
              title={'Ir al recurso'}
              label={'Ir al recurso'}
              format={format}
              downloadURL={downloadURL ? downloadURL : accessURL}
            />
          </>
        );
        break;
      default:
        content = (
          <FileDownload
            title={`Descargar ${format.toUpperCase()}`}
            description={resource.data.title}
            label={'Descargar'}
            format={format}
            hasPreview={false}
            downloadURL={resource.data.downloadURL}
          />
        );
        break;
    }

    return content;
  }

  return (
    <div id={`resource_${resource.identifier}`}>
      {getResourceRender(format.toLowerCase())}
    </div>
  );
};

export default ResourceTemplate;
